// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.buttondesign {
  background-color: #ffd705 !important;
  /* padding: 0.2rem 0rem 0.1rem 0rem !important; */
  /* text-align: center; */
  /* padding: 1rem auto !important; */
  /* height: 1.4rem; */
  border-radius: 6px;
  color: white;
  border: none;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 300;
  padding: 2px 12px;
}
.border_table{
  /* border-bottom: 0.5px solid #DCDCDC !important; */
}
.padding_of_calender {
  padding-left: 15px;
  padding-right: 15px;
}

.padding_fixed_left_right {
  padding-left: 20%;
  padding-right: 20%;
}

.mob_table {
  margin-left: 24px !important;
}

.service_booking_flex {
  margin-left: 15%;
  margin-right: 15%;
}

.service_details {
  margin-left: 40px;
  padding: 10px 30px;
}

.back_btn_div {
  padding-right: 30px;
}

.details_card {
  margin-top: 10px !important;
  margin-left: 20px !important;
}

.provider_box {
  width:9vw ; 
  border-radius:30px; 
  height:2.3rem;
}

.less_than_four{
  width: 15vw !important
}

.less_than_eight {
  width: 11vw !important
}

.provider_circle {
  width: 35px !important; 
  height: 35px !important;
}
.payment_heading{
  color: #8E8E8E;
  font-size: 12px;
  font-weight: 400;
  font-family: Roboto;
}
.widget-service{
  color: #8E8E8E;
  font-size: 12px;
  font-weight: 400;
}
@media (max-width: 500px) {
  .padding_fixed_left_right {
    padding-left: 0;
    padding-right: 0;
    margin: 0px 10px 0px 15px;
  }

  .mob_flex {
    flex-direction: column;
  }

  .mob_table {
    margin-top: 10px !important;
    margin-left: 5px !important;
  }

  .service_booking_flex {
    flex-direction: column;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  .service_details {
    width: 350px !important;
    margin-left: 10px !important;
    margin-right: 10px !important;
  }

  .back_btn_div {
    margin: 10px 15px;
  }

  .service_btn {
    font-size: 12px !important;
    padding: 5px 3px !important;
    font-weight: 600 !important;
  }

  .customer_flex {
    flex-direction: column;
    padding-left: 30px !important;
    padding-right: 30px !important;
  }

  .details_card {
    width: 360px;
    margin-top: 15px !important;
    margin-left: 0 !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .addCustomer_btn {
    font-size: 12px !important;
    padding: 5px 3px !important;
    font-weight: 600 !important;
  }

  .pick_slot_flex {
    flex-direction: column !important;
  }
}

.pading_left_r_new {
  padding-left: 1.5%;
  padding-right: 1.5%;
}

.border_rrad_solid table,
th,
td {
  /* border: 1px solid #f6f6f6 !important; */
  box-shadow: none !important;
  width: 100%;
  cursor: pointer;
}

.MuiPaper-root{
  border-radius: 8px !important;
}

.MuiTableCell-root{
  border: 1px solid transparent !important;
}

.css-qqo6ut-MuiTableCell-root::after{
  border-right: none !important;
}

.table_alignment {
  text-align: left !important;
}

.table_brder_less {
  border: 0px solid white;
}

.border_rrad_solid {
  border-left: 0.6px solid lightgray;
  border-right: 0.6px solid lightgray;
  border-bottom: 0.6px solid lightgray;
  border-radius: 5px;
  height: 60vh;
  overflow-y: scroll;
}

.backgound_white_select_options {
  background-color: white;
  /* border: 0.6px solid rgb(208, 208, 208); */
  border-radius: 6px;
}

.input_select_ser {
  padding: 0px;
  font-size: 12px;
  width: 100%;
  border: 0px solid white;
}

.input_select_ser::-webkit-scrollbar {
  padding-top: 0px !important;
}

.text_select_services {
  color: #8a8a8a;
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
}

#icon_left_color {
  color: rgb(255, 215, 5);
}

.padding_of_cal {
  padding-left: 0;
}

.buttondesign2 {
  background-color: #ffd705 !important;
  /* padding: 0.2rem 0rem 0.1rem 0rem !important; */
  /* text-align: center; */
  padding: 1rem auto !important;
  height: 1.4rem;
  color: #ffffff !important;
  font-size: 0.625rem !important;
  font-weight: 600 !important;
  border: 4px solid white !important;
  box-shadow: 8px 11px 18px 0px rgba(0, 0, 0, 0.2) !important;
}

.icon_size_newplus {
  width: 40%;
}

.btn-border-design {
  border: 0.063rem solid #dcdcdc !important;
  width: 8.813rem !important;
}

.buttontext {
  /* padding-top: 0.5rem; */
  color: #797979 !important;
  /* color: light; */
  font-size: 0.625rem !important;
  font-weight: 600 !important;
}

.buttongroup {
  display: flex;
  align-items: center;
  /* Center the text vertically */
  background-color: #f5f5f5;
  border-radius: 0.5rem;
  height: 1.5rem;
  /* Set a minimum height */
  padding: 0 !important;
  margin: 0 !important;
}

/* Style the buttons within the buttongroup */
.buttongroup button {
  flex: 1 1;
  /* Allow buttons to grow and occupy available space evenly */
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: none;
  cursor: pointer;
  font-size: 0.625rem !important;
  font-weight: 400 !important;
  color: #797979 !important;
}

/* Style the separator between buttons (optional) */
.buttongroup button:not(:last-child)::after {
  /* content: '|'; You can use any separator you prefer */
  margin: 0 0.25rem;
  /* Adjust spacing as needed */
  color: #797979;
  /* Separator color */
}

/* .buttongroup {
  background-color: #f5f5f5;
  border-radius: 0.5rem;
height: 1.5rem !important;
padding: 0 !important;
margin: 0 !important;
} */

.dropDown {
  padding: 0.0625rem 0.625rem !important;
}

.bg_dark {
  background-color: #e9e9e9 !important;
  border-radius: 0.25rem !important;
}

.secondary_fonts {
  color: #717171;
  text-align: center;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  /* line-height: 28.8px; */
}

.date_title {
  font-size: 0.75rem;
  font-weight: 400;
  color: #717171;
  font-family: "Roboto", sans-serif;
}

.filter_title {
  font-size: 0.75rem;
  font-weight: 400;
  color: #797979;
  font-family: "Roboto", sans-serif;
  padding: 0 0.05rem;
}

.bg_light {
  background-color: #f2f3f5 !important;
  border-radius: 0.25rem !important;
}

.primary_fonts {
  color: #252525;
  text-align: center;
  font-family: Roboto;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
}

.card_shadow {
  box-shadow: rgba(99, 99, 99, 0.2) 0 0.125rem 0.5rem 0;
}

.dropdown-toggle::after {
  display: none;
}

.padding_set_day2 {
  padding-top: 2px;
  padding-bottom: 2px;
}

.padding_set_week2 {
  padding-top: 2.5px;
  padding-bottom: 2.5px;
}

.color_week {
  background-color: white !important;
  border: 1px solid rgb(222, 222, 222);
}

.inputField {
  border: none;
}

.inputField:focus {
  outline: none;
}

.bgNone {
  background-color: none !important;
}

.provider_parent {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  white-space: break-spaces;
  border-radius: 3.625rem;
  border: 0.0625rem solid #dcdcdc;
  background: #fff;
  box-shadow: 0 0.25rem 0.375rem 0 rgba(0, 0, 0, 0.06);
}

.provider_title {
  font-size: 0.75rem;
  font-weight: 400;
  color: #555555;
  font-family: "Roboto", sans-serif;
  margin: 0;
  padding: 0;
  width: inherit;
  line-height: normal;
}

.select_service {
  color: #8a8a8a;
  font-family: Roboto;
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
}

.select_input::placeholder {
  font-size: 1.125rem;
  font-weight: 400;
  color: #616161;
  font-family: "Roboto", sans-serif;
}

.select_tablerow1 {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.select_tableheader {
  font-size: 1rem;
  font-weight: 400;
  color: #6b6b6b;
  font-family: "Roboto", sans-serif;
}

.select_tablerow {
  font-size: 0.875rem;
  font-weight: 400;
  color: #616161;
  font-family: "Roboto", sans-serif;
}

.selected_service {
  color: #b3b3b3;
  font-family: "Roboto";
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
}

.selected_servicename {
  color: #443F3F;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  text-transform: capitalize;
}
.service-price{
  color: #443F3F;
  font-family: Roboto;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
}
.selected_serviceduration{
  color: #6C6060;
  font-size: 12px;
  font-weight: 400;
  text-transform: lowercase;
}
.selected_servicevalue{
  color: #AEAEAE;
  font-size: 12px;
  font-weight: 400;
}
.serviceprice{
  color: #433C3C;
  font-size: 15px;
  font-weight: 500;
  font-family: Roboto;
  text-align: center;
}
.service-text-heading{
  color: #666666;
  font-size: 14px;
  font-weight: 400;
  font-family: Roboto;
}
.pointer {
  cursor: pointer;
}

.selected_servicecount {
  font-size: 1rem;
  font-weight: 500;
  color: #4d4d4d;
  font-family: "Roboto", sans-serif;
}

.bg_tab {
  background-color: #fbfcff !important;
  border: 0.0625rem solid #f0f0f0 !important;
  border-radius: 0.313rem !important;
  font-size: 1.125rem !important;
  font-weight: 500 !important;
  color: #616161 !important;
  font-family: "Roboto", sans-serif !important;
}

.border_h6 {
  border: 1px solid rgb(222, 222, 222);
  border-radius: 5px;
  padding-top: 4.5px;
  padding-bottom: 4.5px;
}

.border_up_and_down {
  border-top: 1px solid rgb(222, 222, 222);
  border-bottom: 1px solid rgb(222, 222, 222);
}
.servicedetails-heading{
  color: #8E8E8E;
  font-size: 12px;
  font-weight: 400;
}
.attribute-value{
  color: #5D5D5D;
  font-size: 14px;
  font-weight: 400;
  font-family: Roboto;
}
.attribute-duration{
  color: #BBBBBB;
  font-size: 12px;
  font-weight: 400;
  font-family: Roboto;
}
.attribute-description{
  color: #AEAEAE;
  font-size: 12px;
  font-weight: 400;
  font-family: Roboto;
}
.attribute-price{
  color: #908888;
  font-size: 14px;
  font-weight: 400;
  font-family: Roboto;
}
.add-customer-heading{
  color: #8E8E8E;
  font-size: 12px;
  font-weight: 400;
  font-family: Roboto;
}
.add-customer-quantity{
  color: #616161;
  font-size: 12px;
  font-weight: 400;
  font-family: Roboto;
}
.customer-label-text{
  color: #8A8A8A;
  font-size: 10px;
  font-weight: 400;
  font-family: Roboto;
}
.customer-input-style{
  color: #231F1F !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  font-family: Roboto !important;
}
.customer-input-style::placeholder{
  color: #A4A4A4;
  font-size: 12px;
  font-weight: 400;
  font-family: Roboto;
}
.add-customer-date{
  color: #443F3F;
  font-size: 14px;
  font-weight: 400;
  font-family: Roboto;
}
/* .select-service-input{
  color: "#1C1B1B" !important;
  font-family: "Poppins";
  font-size: "14px" !important;
  font-style: "normal";
  font-weight: 400;
  border: "none";
  background-color: "transparent";                                            
} */
.select-service-input::placeholder{
  color: "#838383" !important;
  font-family: "Roboto";
  font-size: "12px" !important;
  font-style: "normal";
  font-weight: 400;
  border: "none" !important;
  background-color: "transparent" !important; 
                                               
}
.widget-quantity{
  color: #616161;
  font-size: 12px;
  font-weight: 400;
}
.widget_servicename{
  color: #443F3F;
  font-size: 14px;
  font-weight: 500;
  text-transform: capitalize;
}
.widget_serviceduration{
  color: #6C6060;
  font-size: 12px;
  font-weight: 400;
  padding-left: 4px;
  text-transform: lowercase;
}
.widget_price{
  color: #433C3C;
  font-size: 15px;
  font-weight: 500;
  margin-top: -13px;
}
.widget_description{
  color: #AEAEAE;
  font-size: 12px;
  font-weight: 400;
}
@media (max-width: 700px) {
  .provider_title{
    font-size: 0.5rem;
  }
  .provider_box {
    width: 65px;
    height: 1.8rem;
  }
  .provider_circle{
    width: 28px !important; height: 28px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/Calendar/assets/scheduler/css/calendar.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC,iDAAiD;EACjD,wBAAwB;EACxB,mCAAmC;EACnC,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,mDAAmD;AACrD;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;IACf,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,2BAA2B;IAC3B,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;IACtB,yBAAyB;IACzB,0BAA0B;EAC5B;;EAEA;IACE,uBAAuB;IACvB,4BAA4B;IAC5B,6BAA6B;EAC/B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;IACtB,6BAA6B;IAC7B,8BAA8B;EAChC;;EAEA;IACE,YAAY;IACZ,2BAA2B;IAC3B,yBAAyB;IACzB,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,2BAA2B;EAC7B;;EAEA;IACE,iCAAiC;EACnC;AACF;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;;EAGE,0CAA0C;EAC1C,2BAA2B;EAC3B,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;EAClC,mCAAmC;EACnC,oCAAoC;EACpC,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,4CAA4C;EAC5C,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,iDAAiD;EACjD,wBAAwB;EACxB,6BAA6B;EAC7B,cAAc;EACd,yBAAyB;EACzB,8BAA8B;EAC9B,2BAA2B;EAC3B,kCAAkC;EAClC,2DAA2D;AAC7D;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yCAAyC;EACzC,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA,6CAA6C;AAC7C;EACE,SAAO;EACP,4DAA4D;EAC5D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,8BAA8B;EAC9B,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA,mDAAmD;AACnD;EACE,uDAAuD;EACvD,iBAAiB;EACjB,6BAA6B;EAC7B,cAAc;EACd,oBAAoB;AACtB;;AAEA;;;;;;GAMG;;AAEH;EACE,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,yBAAyB;EACzB,uBAAuB;EACvB,+BAA+B;EAC/B,gBAAgB;EAChB,oDAAoD;AACtD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,iCAAiC;EACjC,SAAS;EACT,UAAU;EACV,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,kCAAkC;EAClC,8BAA8B;EAC9B,2BAA2B;EAC3B,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,wCAAwC;EACxC,2CAA2C;AAC7C;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,8BAA8B;AAChC;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;;;;;;;;GAQG;AACH;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,4BAA4B;EAC5B,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;EACzB,0CAA0C;;AAE5C;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,cAAc;EAChB;EACA;IACE,sBAAsB,EAAE,uBAAuB;EACjD;AACF","sourcesContent":[".buttondesign {\n  background-color: #ffd705 !important;\n  /* padding: 0.2rem 0rem 0.1rem 0rem !important; */\n  /* text-align: center; */\n  /* padding: 1rem auto !important; */\n  /* height: 1.4rem; */\n  border-radius: 6px;\n  color: white;\n  border: none;\n  text-align: center;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 300;\n  padding: 2px 12px;\n}\n.border_table{\n  /* border-bottom: 0.5px solid #DCDCDC !important; */\n}\n.padding_of_calender {\n  padding-left: 15px;\n  padding-right: 15px;\n}\n\n.padding_fixed_left_right {\n  padding-left: 20%;\n  padding-right: 20%;\n}\n\n.mob_table {\n  margin-left: 24px !important;\n}\n\n.service_booking_flex {\n  margin-left: 15%;\n  margin-right: 15%;\n}\n\n.service_details {\n  margin-left: 40px;\n  padding: 10px 30px;\n}\n\n.back_btn_div {\n  padding-right: 30px;\n}\n\n.details_card {\n  margin-top: 10px !important;\n  margin-left: 20px !important;\n}\n\n.provider_box {\n  width:9vw ; \n  border-radius:30px; \n  height:2.3rem;\n}\n\n.less_than_four{\n  width: 15vw !important\n}\n\n.less_than_eight {\n  width: 11vw !important\n}\n\n.provider_circle {\n  width: 35px !important; \n  height: 35px !important;\n}\n.payment_heading{\n  color: #8E8E8E;\n  font-size: 12px;\n  font-weight: 400;\n  font-family: Roboto;\n}\n.widget-service{\n  color: #8E8E8E;\n  font-size: 12px;\n  font-weight: 400;\n}\n@media (max-width: 500px) {\n  .padding_fixed_left_right {\n    padding-left: 0;\n    padding-right: 0;\n    margin: 0px 10px 0px 15px;\n  }\n\n  .mob_flex {\n    flex-direction: column;\n  }\n\n  .mob_table {\n    margin-top: 10px !important;\n    margin-left: 5px !important;\n  }\n\n  .service_booking_flex {\n    flex-direction: column;\n    margin-left: 0 !important;\n    margin-right: 0 !important;\n  }\n\n  .service_details {\n    width: 350px !important;\n    margin-left: 10px !important;\n    margin-right: 10px !important;\n  }\n\n  .back_btn_div {\n    margin: 10px 15px;\n  }\n\n  .service_btn {\n    font-size: 12px !important;\n    padding: 5px 3px !important;\n    font-weight: 600 !important;\n  }\n\n  .customer_flex {\n    flex-direction: column;\n    padding-left: 30px !important;\n    padding-right: 30px !important;\n  }\n\n  .details_card {\n    width: 360px;\n    margin-top: 15px !important;\n    margin-left: 0 !important;\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n\n  .addCustomer_btn {\n    font-size: 12px !important;\n    padding: 5px 3px !important;\n    font-weight: 600 !important;\n  }\n\n  .pick_slot_flex {\n    flex-direction: column !important;\n  }\n}\n\n.pading_left_r_new {\n  padding-left: 1.5%;\n  padding-right: 1.5%;\n}\n\n.border_rrad_solid table,\nth,\ntd {\n  /* border: 1px solid #f6f6f6 !important; */\n  box-shadow: none !important;\n  width: 100%;\n  cursor: pointer;\n}\n\n.MuiPaper-root{\n  border-radius: 8px !important;\n}\n\n.MuiTableCell-root{\n  border: 1px solid transparent !important;\n}\n\n.css-qqo6ut-MuiTableCell-root::after{\n  border-right: none !important;\n}\n\n.table_alignment {\n  text-align: left !important;\n}\n\n.table_brder_less {\n  border: 0px solid white;\n}\n\n.border_rrad_solid {\n  border-left: 0.6px solid lightgray;\n  border-right: 0.6px solid lightgray;\n  border-bottom: 0.6px solid lightgray;\n  border-radius: 5px;\n  height: 60vh;\n  overflow-y: scroll;\n}\n\n.backgound_white_select_options {\n  background-color: white;\n  /* border: 0.6px solid rgb(208, 208, 208); */\n  border-radius: 6px;\n}\n\n.input_select_ser {\n  padding: 0px;\n  font-size: 12px;\n  width: 100%;\n  border: 0px solid white;\n}\n\n.input_select_ser::-webkit-scrollbar {\n  padding-top: 0px !important;\n}\n\n.text_select_services {\n  color: #8a8a8a;\n  font-family: Roboto;\n  font-size: 12px;\n  font-style: normal;\n}\n\n#icon_left_color {\n  color: rgb(255, 215, 5);\n}\n\n.padding_of_cal {\n  padding-left: 0;\n}\n\n.buttondesign2 {\n  background-color: #ffd705 !important;\n  /* padding: 0.2rem 0rem 0.1rem 0rem !important; */\n  /* text-align: center; */\n  padding: 1rem auto !important;\n  height: 1.4rem;\n  color: #ffffff !important;\n  font-size: 0.625rem !important;\n  font-weight: 600 !important;\n  border: 4px solid white !important;\n  box-shadow: 8px 11px 18px 0px rgba(0, 0, 0, 0.2) !important;\n}\n\n.icon_size_newplus {\n  width: 40%;\n}\n\n.btn-border-design {\n  border: 0.063rem solid #dcdcdc !important;\n  width: 8.813rem !important;\n}\n\n.buttontext {\n  /* padding-top: 0.5rem; */\n  color: #797979 !important;\n  /* color: light; */\n  font-size: 0.625rem !important;\n  font-weight: 600 !important;\n}\n\n.buttongroup {\n  display: flex;\n  align-items: center;\n  /* Center the text vertically */\n  background-color: #f5f5f5;\n  border-radius: 0.5rem;\n  height: 1.5rem;\n  /* Set a minimum height */\n  padding: 0 !important;\n  margin: 0 !important;\n}\n\n/* Style the buttons within the buttongroup */\n.buttongroup button {\n  flex: 1;\n  /* Allow buttons to grow and occupy available space evenly */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  background: none;\n  cursor: pointer;\n  font-size: 0.625rem !important;\n  font-weight: 400 !important;\n  color: #797979 !important;\n}\n\n/* Style the separator between buttons (optional) */\n.buttongroup button:not(:last-child)::after {\n  /* content: '|'; You can use any separator you prefer */\n  margin: 0 0.25rem;\n  /* Adjust spacing as needed */\n  color: #797979;\n  /* Separator color */\n}\n\n/* .buttongroup {\n  background-color: #f5f5f5;\n  border-radius: 0.5rem;\nheight: 1.5rem !important;\npadding: 0 !important;\nmargin: 0 !important;\n} */\n\n.dropDown {\n  padding: 0.0625rem 0.625rem !important;\n}\n\n.bg_dark {\n  background-color: #e9e9e9 !important;\n  border-radius: 0.25rem !important;\n}\n\n.secondary_fonts {\n  color: #717171;\n  text-align: center;\n  font-family: Roboto;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  /* line-height: 28.8px; */\n}\n\n.date_title {\n  font-size: 0.75rem;\n  font-weight: 400;\n  color: #717171;\n  font-family: \"Roboto\", sans-serif;\n}\n\n.filter_title {\n  font-size: 0.75rem;\n  font-weight: 400;\n  color: #797979;\n  font-family: \"Roboto\", sans-serif;\n  padding: 0 0.05rem;\n}\n\n.bg_light {\n  background-color: #f2f3f5 !important;\n  border-radius: 0.25rem !important;\n}\n\n.primary_fonts {\n  color: #252525;\n  text-align: center;\n  font-family: Roboto;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 600;\n}\n\n.card_shadow {\n  box-shadow: rgba(99, 99, 99, 0.2) 0 0.125rem 0.5rem 0;\n}\n\n.dropdown-toggle::after {\n  display: none;\n}\n\n.padding_set_day2 {\n  padding-top: 2px;\n  padding-bottom: 2px;\n}\n\n.padding_set_week2 {\n  padding-top: 2.5px;\n  padding-bottom: 2.5px;\n}\n\n.color_week {\n  background-color: white !important;\n  border: 1px solid rgb(222, 222, 222);\n}\n\n.inputField {\n  border: none;\n}\n\n.inputField:focus {\n  outline: none;\n}\n\n.bgNone {\n  background-color: none !important;\n}\n\n.provider_parent {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-evenly;\n  align-items: center;\n  white-space: break-spaces;\n  border-radius: 3.625rem;\n  border: 0.0625rem solid #dcdcdc;\n  background: #fff;\n  box-shadow: 0 0.25rem 0.375rem 0 rgba(0, 0, 0, 0.06);\n}\n\n.provider_title {\n  font-size: 0.75rem;\n  font-weight: 400;\n  color: #555555;\n  font-family: \"Roboto\", sans-serif;\n  margin: 0;\n  padding: 0;\n  width: inherit;\n  line-height: normal;\n}\n\n.select_service {\n  color: #8a8a8a;\n  font-family: Roboto;\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 500;\n}\n\n.select_input::placeholder {\n  font-size: 1.125rem;\n  font-weight: 400;\n  color: #616161;\n  font-family: \"Roboto\", sans-serif;\n}\n\n.select_tablerow1 {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.select_tableheader {\n  font-size: 1rem;\n  font-weight: 400;\n  color: #6b6b6b;\n  font-family: \"Roboto\", sans-serif;\n}\n\n.select_tablerow {\n  font-size: 0.875rem;\n  font-weight: 400;\n  color: #616161;\n  font-family: \"Roboto\", sans-serif;\n}\n\n.selected_service {\n  color: #b3b3b3;\n  font-family: \"Roboto\";\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 500;\n}\n\n.selected_servicename {\n  color: #443F3F;\n  font-family: Roboto;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  text-transform: capitalize;\n}\n.service-price{\n  color: #443F3F;\n  font-family: Roboto;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 500;\n}\n.selected_serviceduration{\n  color: #6C6060;\n  font-size: 12px;\n  font-weight: 400;\n  text-transform: lowercase;\n}\n.selected_servicevalue{\n  color: #AEAEAE;\n  font-size: 12px;\n  font-weight: 400;\n}\n.serviceprice{\n  color: #433C3C;\n  font-size: 15px;\n  font-weight: 500;\n  font-family: Roboto;\n  text-align: center;\n}\n.service-text-heading{\n  color: #666666;\n  font-size: 14px;\n  font-weight: 400;\n  font-family: Roboto;\n}\n.pointer {\n  cursor: pointer;\n}\n\n.selected_servicecount {\n  font-size: 1rem;\n  font-weight: 500;\n  color: #4d4d4d;\n  font-family: \"Roboto\", sans-serif;\n}\n\n.bg_tab {\n  background-color: #fbfcff !important;\n  border: 0.0625rem solid #f0f0f0 !important;\n  border-radius: 0.313rem !important;\n  font-size: 1.125rem !important;\n  font-weight: 500 !important;\n  color: #616161 !important;\n  font-family: \"Roboto\", sans-serif !important;\n}\n\n.border_h6 {\n  border: 1px solid rgb(222, 222, 222);\n  border-radius: 5px;\n  padding-top: 4.5px;\n  padding-bottom: 4.5px;\n}\n\n.border_up_and_down {\n  border-top: 1px solid rgb(222, 222, 222);\n  border-bottom: 1px solid rgb(222, 222, 222);\n}\n.servicedetails-heading{\n  color: #8E8E8E;\n  font-size: 12px;\n  font-weight: 400;\n}\n.attribute-value{\n  color: #5D5D5D;\n  font-size: 14px;\n  font-weight: 400;\n  font-family: Roboto;\n}\n.attribute-duration{\n  color: #BBBBBB;\n  font-size: 12px;\n  font-weight: 400;\n  font-family: Roboto;\n}\n.attribute-description{\n  color: #AEAEAE;\n  font-size: 12px;\n  font-weight: 400;\n  font-family: Roboto;\n}\n.attribute-price{\n  color: #908888;\n  font-size: 14px;\n  font-weight: 400;\n  font-family: Roboto;\n}\n.add-customer-heading{\n  color: #8E8E8E;\n  font-size: 12px;\n  font-weight: 400;\n  font-family: Roboto;\n}\n.add-customer-quantity{\n  color: #616161;\n  font-size: 12px;\n  font-weight: 400;\n  font-family: Roboto;\n}\n.customer-label-text{\n  color: #8A8A8A;\n  font-size: 10px;\n  font-weight: 400;\n  font-family: Roboto;\n}\n.customer-input-style{\n  color: #231F1F !important;\n  font-size: 14px !important;\n  font-weight: 400 !important;\n  font-family: Roboto !important;\n}\n.customer-input-style::placeholder{\n  color: #A4A4A4;\n  font-size: 12px;\n  font-weight: 400;\n  font-family: Roboto;\n}\n.add-customer-date{\n  color: #443F3F;\n  font-size: 14px;\n  font-weight: 400;\n  font-family: Roboto;\n}\n/* .select-service-input{\n  color: \"#1C1B1B\" !important;\n  font-family: \"Poppins\";\n  font-size: \"14px\" !important;\n  font-style: \"normal\";\n  font-weight: 400;\n  border: \"none\";\n  background-color: \"transparent\";                                            \n} */\n.select-service-input::placeholder{\n  color: \"#838383\" !important;\n  font-family: \"Roboto\";\n  font-size: \"12px\" !important;\n  font-style: \"normal\";\n  font-weight: 400;\n  border: \"none\" !important;\n  background-color: \"transparent\" !important; \n                                               \n}\n.widget-quantity{\n  color: #616161;\n  font-size: 12px;\n  font-weight: 400;\n}\n.widget_servicename{\n  color: #443F3F;\n  font-size: 14px;\n  font-weight: 500;\n  text-transform: capitalize;\n}\n.widget_serviceduration{\n  color: #6C6060;\n  font-size: 12px;\n  font-weight: 400;\n  padding-left: 4px;\n  text-transform: lowercase;\n}\n.widget_price{\n  color: #433C3C;\n  font-size: 15px;\n  font-weight: 500;\n  margin-top: -13px;\n}\n.widget_description{\n  color: #AEAEAE;\n  font-size: 12px;\n  font-weight: 400;\n}\n@media (max-width: 700px) {\n  .provider_title{\n    font-size: 0.5rem;\n  }\n  .provider_box {\n    width: 65px;\n    height: 1.8rem;\n  }\n  .provider_circle{\n    width: 28px !important; height: 28px !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
